/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { ConnectedDialog } from '../ConnectedDialog';
import { useSelectWithParams } from '../../../utils/selector.utils';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { IMeetingTemplatesFormDialogProps } from './types';
import MeetingTemplatesForm from './MeetingTemplatesForm';
import { fetchMeetingTemplates } from '../../../app/page/page-storage/meeting-templates/meeting-templates.actions';
import { getAgendaItems } from '../../../app/page/page-storage/agenda-items/agenda-items.actions';

export const MeetingTemplatesFormDialog: FunctionComponent<IMeetingTemplatesFormDialogProps> = () => {
  const dispatch = useDispatch();
  const isOpen = useSelectWithParams(dialogSelectors.selectIsDialogOpen, 'meetingTemplatesFormDialog');

  useEffect(() => {
    if (isOpen) {
      dispatch(fetchMeetingTemplates());
      dispatch(getAgendaItems());
    }
  }, [dispatch, isOpen]);

  const onClose = useCallback(() => {
    dispatch(closeDialog('meetingTemplatesFormDialog'));
  }, [dispatch]);

  return (
    <ConnectedDialog dialogKey="meetingTemplatesFormDialog">
      <div>
        <div className="panel fixed-panel" style={{ width: 'auto' }}>
          <MeetingTemplatesForm onClose={onClose} />
        </div>
      </div>
    </ConnectedDialog>
  );
};
